var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component, Fragment } from "react";
import { DragDropContext, Draggable, Droppable, } from "react-beautiful-dnd";
import { getActionPlanTemplateFromDto, getRequestFromActionPlanTemplate, } from "../../shared/domainTypes/task/actionPlanTemplate.type";
import { TaskPriorities } from "../../shared/domainTypes/task/task.type";
import { getBlankTaskTemplate, } from "../../shared/domainTypes/task/taskTemplate.type";
import Modal from "../../shared/modal";
import TaskService from "../../../services/TaskService";
import { TemplateModal } from "./actionPlanFormModals";
import DeprecatedSelect from "../../../src/View/UI/DeprecatedSelect/DeprecatedSelect";
import { getXSRF } from "../../../src/Services/Shared/FetchService";
// TODO This component is approaching 700 lines.  It needs to be broken into smaller components.
export default class ActionPlanForm extends Component {
    constructor(props) {
        super(props);
        this.handleChange = (event) => {
            const { target } = event;
            const value = target.type === "checkbox" ? target.checked : target.value;
            const { name } = target;
            this.setState({
                plan: Object.assign(Object.assign({}, this.state.plan), { [name]: value }),
                saved: false,
            });
            if (this.props.onChange) {
                this.props.onChange();
            }
        };
        this.hasBeenEdited = (template) => template.meta.isModified;
        this.isNewlyAdded = (template) => template.meta.isNew;
        this.wasJustCreated = (template) => template.meta.isCreated;
        this.handleSelectChange = (name) => (newValues) => {
            // Because react-select is dumb and poorly written, we have to map values
            // coming in and out of it. It's not possible to just have the value be the object,
            // it has to be on some attribute on the object.  Dumb.
            if (Array.isArray(newValues)) {
                this.setState({
                    plan: Object.assign(Object.assign({}, this.state.plan), { [name]: newValues.map((value) => value.value) }),
                });
            }
            else {
                this.setState({
                    plan: Object.assign(Object.assign({}, this.state.plan), { [name]: newValues ? newValues.value : null }),
                });
            }
            this.setState({
                saved: false,
            });
            if (this.props.onChange) {
                this.props.onChange();
            }
        };
        this.handleSubmit = (event) => __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            this.setState({ saving: true });
            const plan = Object.assign(Object.assign({}, this.state.plan), { templates: this.state.plan.templates.map(this._stripMetaInfoFromTaskTemplate) });
            // Validate the plan
            const validation = TaskService.validateActionPlanTemplate(plan);
            if (!validation.isValid) {
                this.setState({ saving: false });
                if (this.props.onError) {
                    this.props.onError(validation.errorMessage);
                }
                console.error("Validation error on plan", validation.errorMessage);
                return;
            }
            // Expect SingleResponse<TaskTemplateDto>  This will break otherwise.
            const response = yield fetch("/aviso/taskAdmin/saveActionPlanTemplate", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "X-XSRF-TOKEN": getXSRF(),
                },
                body: JSON.stringify({
                    template: getRequestFromActionPlanTemplate(plan),
                }),
            });
            let data;
            try {
                data = yield response.json();
            }
            catch (error) {
                this.setState({ saving: false });
                console.error(error);
                if (this.props.onError) {
                    this.props.onError("There was an error on the server saving that plan");
                }
                return;
            }
            this.setState({ saving: false });
            if (!response.ok) {
                console.error("Got bad response from server", response, data);
                if (data && this.props.onError) {
                    this.props.onError(data.message ? data.message.toString() : this.defaultErrorMessage);
                }
            }
            else if (!data.success) {
                console.error("Got failed SingleResponse:", data);
                if (this.props.onError) {
                    this.props.onError(data.message ? data.message.toString() : this.defaultErrorMessage);
                }
            }
            else {
                let newPlan;
                try {
                    newPlan = getActionPlanTemplateFromDto(data.data);
                }
                catch (error) {
                    console.error("Could not convert data to plan.  Got data", data);
                    if (this.props.onError) {
                        this.props.onError(error ? error.toString() : this.defaultErrorMessage);
                    }
                    return;
                }
                if (this.props.onSave) {
                    this.props.onSave(plan);
                }
                // We need to add the templateListIds to the templates in this plan.
                this.setState({
                    plan: Object.assign(Object.assign({}, newPlan), { templates: newPlan.templates.map(this._getTemplateWithMetaFromTemplate) }),
                    saved: true,
                    saving: false,
                });
            }
        });
        /**
         * Called when a new template is added to the plan
         *
         * @param {TaskTemplate} addedTemplate - The new template
         */
        this.handleAddTemplate = (addedTemplate) => {
            const createdTemplate = this._getTemplateWithMetaFromTemplate(addedTemplate);
            createdTemplate.meta.isCreated = true;
            this.setState((prevState) => ({
                newTaskTemplateModalOpen: false,
                saved: false,
                plan: Object.assign(Object.assign({}, prevState.plan), { templates: prevState.plan.templates.concat(createdTemplate) }),
            }));
            if (this.props.onChange) {
                this.props.onChange();
            }
        };
        /*
         * Called when a existing template is selected to be added to this plan.
         */
        this.handleSelectTemplate = ({ value }) => {
            const template = this._getTemplateWithMetaFromTemplate(value);
            template.meta.isNew = true;
            this.setState((prevState) => ({
                plan: Object.assign(Object.assign({}, prevState.plan), { templates: prevState.plan.templates.concat(template) }),
                saved: false,
            }));
            if (this.props.onChange) {
                this.props.onChange();
            }
        };
        /**
         * Called when edits to a template are saved.
         *
         *  @param {TaskTemplate} editedTemplate - the edited template
         */
        this.handleEditTemplate = (editedTemplate) => {
            // Copy over the changes into all templates that have the same
            // template id as the template in the edit modal and mark them as modified.
            let newTemplates = [];
            // If the edited template is new and doesn't  have an id,
            // we need to identify it by the taskTemplateListId and not the id.
            // otherwise just identify it by the id.  Keep in mind that the same
            // task template can be used many times within an action plan.
            if (!editedTemplate.id) {
                newTemplates = this.state.plan.templates.map((template) => template.meta.taskTemplateListId ===
                    this.state.templateInEditModalMetaInfo.taskTemplateListId
                    ? Object.assign(Object.assign({}, editedTemplate), { meta: Object.assign(Object.assign({}, template.meta), { isModified: true }) }) : template);
            }
            else {
                newTemplates = this.state.plan.templates.map((template) => template.id === editedTemplate.id
                    ? Object.assign(Object.assign({}, editedTemplate), { meta: Object.assign(Object.assign({}, template.meta), { isModified: true }) }) : template);
            }
            this.setState((prevState) => ({
                plan: Object.assign(Object.assign({}, prevState.plan), { templates: newTemplates }),
                saved: false,
                templateInEditModal: null,
                templateInEditModalChanges: {},
                templateInEditModalMetaInfo: {},
            }));
            if (this.props.onChange) {
                this.props.onChange();
            }
        };
        this.handleDeleteTemplate = (index) => {
            if (index == null) {
                return;
            }
            // Remove the template at index from this.state.plan.templates.
            this.setState((prevState) => ({
                plan: Object.assign(Object.assign({}, prevState.plan), { templates: prevState.plan.templates
                        .slice(0, index)
                        .concat(prevState.plan.templates.slice(index + 1)) }),
                saved: false,
                templateToRemove: null,
            }));
            if (this.props.onChange) {
                this.props.onChange();
            }
        };
        this.handleDragEnd = (result) => {
            if (result.destination) {
                const templatesCopy = Array.from(this.state.plan.templates);
                const [removedItem] = templatesCopy.splice(result.source.index, 1);
                templatesCopy.splice(result.destination.index, 0, removedItem);
                this.setState({
                    plan: Object.assign(Object.assign({}, this.state.plan), { templates: templatesCopy }),
                    saved: false,
                });
                if (this.props.onChange) {
                    this.props.onChange();
                }
            }
        };
        this.renderTemplate = (template, index) => {
            let helpText = "";
            if (this.wasJustCreated(template) ||
                this.hasBeenEdited(template) ||
                this.isNewlyAdded(template)) {
                helpText = " (Unsaved)";
            }
            const numActionPlansUsedIn = TaskService.getNumberOfActionPlansTemplateUsedIn(template, this.state.plan.id ? new Set([this.state.plan.id]) : new Set());
            const templateTitle = template.templateTitle || template.title;
            return (_jsx(Draggable, { draggableId: template.meta.taskTemplateListId.toString(), index: index, children: (provided) => (_jsx("div", Object.assign({}, provided.draggableProps, provided.dragHandleProps, { ref: provided.innerRef, className: `list-group-item d-flex flex-column ${template.enabled ? "" : "bg-gray"}`, title: !template.enabled
                        ? "This template is not enabled.  It will not appear in the action plan."
                        : undefined, children: _jsxs("div", { className: "d-flex justify-content-between align-items-center", children: [_jsxs("div", { children: [_jsx("span", { className: "fas fa-grip-horizontal text-muted mr-3", "aria-hidden": true, title: "Drag to reorder this template" }), template.usages && numActionPlansUsedIn ? (_jsx("span", { className: "fas fa-fw fa-link text-muted mr-3", "aria-hidden": true, title: `This template is used in ${numActionPlansUsedIn} other action plan template${numActionPlansUsedIn > 1 ? "s" : ""}.` })) : (_jsx("span", { className: "fas fa-fw mr-3", "aria-hidden": true })), template.enabled ? templateTitle : _jsx("del", { children: templateTitle }), _jsxs("span", { className: "text-muted", children: [helpText, !template.enabled ? " (Disabled)" : ""] })] }), _jsxs("div", { children: [_jsx("button", { type: "button", className: "btn btn-link", title: "Edit this template", onClick: () => {
                                            this.setState({
                                                // Deep copy template
                                                templateInEditModal: JSON.parse(JSON.stringify(template)),
                                                templateInEditModalMetaInfo: template.meta,
                                            });
                                        }, children: _jsx("span", { className: "fa fa-pencil-alt text-primary mr-3", "aria-hidden": true }) }), _jsxs("button", { type: "button", className: "btn btn-link", title: "Remove this template from the action plan", onClick: () => this.setState({ templateToRemove: index }), children: [_jsx("span", { className: "fas fa-trash text-danger", "aria-hidden": true }), _jsx("span", { className: "sr-only", children: "Remove this template" })] })] })] }) }))) }, template.meta.taskTemplateListId));
        };
        this._stripMetaInfoFromTaskTemplate = (template) => {
            const { meta } = template, everythingElse = __rest(template, ["meta"]); // eslint-disable-line no-unused-vars
            return everythingElse;
        };
        this._getTemplateWithMetaFromTemplate = (template) => (Object.assign(Object.assign({}, template), { meta: {
                isCreated: false,
                isNew: false,
                isModified: false,
                taskTemplateListId: this._getNextTaskTemplateListId(),
            } }));
        this._getNextTaskTemplateListId = () => this._nextTaskTemplateListId++; // eslint-disable-line no-plusplus
        this._fetchAssociatedPeople = (search) => __awaiter(this, void 0, void 0, function* () {
            const peopleMax = 10;
            const people = yield TaskService.getAssociatedPeople(search, peopleMax);
            // Grrr. react-select v1 suuuucks
            return {
                options: people.map((person) => ({
                    label: person.fullName,
                    value: person,
                })),
            };
        });
        this._fetchResources = (search) => __awaiter(this, void 0, void 0, function* () {
            const resourceMax = 10;
            const resources = yield TaskService.getResources(search, resourceMax);
            return {
                options: resources.map((resource) => ({
                    label: resource.name,
                    value: resource,
                })),
            };
        });
        this._fetchTemplates = (search) => __awaiter(this, void 0, void 0, function* () {
            const templatesMax = 10;
            const templates = yield TaskService.getTaskTemplatesWithUsages(search, templatesMax);
            return {
                options: templates.map((template) => ({
                    label: template.templateTitle,
                    value: Object.assign({ templateListId: this._nextTaskTemplateListId++ }, template),
                })),
            };
        });
        const stateDefaultValues = {
            saving: false,
            saved: false,
            newTemplateInModal: getBlankTaskTemplate(),
            templateInEditModal: null,
            templateInEditModalChanges: {},
            templateInEditModalMetaInfo: {},
            newTaskTemplateModalOpen: false,
            templateToRemove: null,
            resourcesAreActive: false,
        };
        this._nextTaskTemplateListId = 0;
        if (!this.props.plan) {
            this.state = Object.assign(Object.assign({}, stateDefaultValues), { plan: {
                    title: "",
                    templates: [],
                    enabled: true,
                    priority: TaskPriorities.medium,
                } });
        }
        else {
            this.state = Object.assign(Object.assign({}, stateDefaultValues), { plan: Object.assign(Object.assign({}, this.props.plan), { templates: this.props.plan.templates.map(this._getTemplateWithMetaFromTemplate) }) });
        }
        this.defaultErrorMessage = "Something went wrong.";
        TaskService.fetchAreResourcesActive().then((resourcesAreActive) => this.setState({ resourcesAreActive }));
        // Ensure that there are no id collisions.
        this.templateFormId = "templateForm-" + Math.floor(Math.random() * 100000);
        this._enabledCheckBoxId =
            "action-plan-template-enabled-" + Math.floor(Math.random() * 1000000);
    }
    render() {
        let saveButtonValue = "Save";
        if (this.state.saving) {
            saveButtonValue = "Saving";
        }
        else if (this.state.saved) {
            saveButtonValue = "Saved";
        }
        return (_jsxs(Fragment, { children: [_jsxs("form", { onSubmit: this.handleSubmit, children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "templateTitle", children: "Action Plan Template Title" }), _jsx("input", { type: "text", value: this.state.plan.templateTitle
                                        ? this.state.plan.templateTitle
                                        : "", className: "form-control", autoComplete: "off", id: "templateTitle", name: "templateTitle", onChange: this.handleChange }), _jsx("small", { className: "text-muted form-text", children: "This is the title you will see when selecting an Action Plan Template to apply to a student. In general, the Action Plan Template Title should be staff-facing and the Action Plan Title should be student-facing. Leaving this blank will make this title the same as the Action Plan Title." })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "templateDescription", children: "Action Plan Template Description" }), _jsx("textarea", { className: "form-control", value: this.state.plan.templateDescription
                                        ? this.state.plan.templateDescription
                                        : "", id: "templateDescription", name: "templateDescription", onChange: this.handleChange }), _jsx("small", { className: "text-muted form-text", children: "A description of this template, maybe to give some context about when this template should be used." })] }), _jsxs("div", { className: "form-group", children: [_jsxs("div", { className: "custom-control custom-checkbox", children: [_jsx("input", { type: "checkbox", className: "custom-control-input", id: this._enabledCheckBoxId, checked: this.state.plan.enabled, name: "enabled", onChange: this.handleChange, 
                                            // If this element is included in a form, when enter is pressed,
                                            // the form is submitted. This behavior on checkbox elements is prone
                                            // to accidental submission, so for this element we will disable the
                                            // default behavior if the enter key is pressed.
                                            onKeyPress: (e) => e.which === 13 && e.preventDefault() }), _jsx("label", { className: "custom-control-label", htmlFor: this._enabledCheckBoxId, children: "Enabled" })] }), _jsx("small", { className: "text-muted form-text", children: "Disabling this template will not allow users to create action plans from this template. Action plans already created from this template will be unaffected." })] }), _jsx("hr", {}), _jsxs("div", { className: "form-group required", children: [_jsx("label", { htmlFor: "title", children: "Action Plan Title" }), _jsx("input", { type: "text", value: this.state.plan.title ? this.state.plan.title : "", className: "form-control", autoComplete: "off", id: "title", name: "title", required: true, onChange: this.handleChange }), _jsx("small", { className: "text-muted form-text", children: "The title of the Action Plan this template will create" })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "description", children: "Description" }), _jsx("textarea", { className: "form-control", value: this.state.plan.description
                                        ? this.state.plan.description
                                        : undefined, id: "description", name: "description", onChange: this.handleChange })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "priority", children: "Priority" }), _jsx(DeprecatedSelect, { "aria-label": "Priority", id: "priority", value: this.state.plan.priority
                                        ? {
                                            value: this.state.plan.priority,
                                            label: this.state.plan.priority.label,
                                        }
                                        : "", options: Object.values(TaskPriorities).map((taskPriority) => {
                                        return {
                                            value: taskPriority,
                                            label: taskPriority.label,
                                        };
                                    }), onChange: this.handleSelectChange("priority"), clearable: false })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "associatedPeople", children: "People That Can Help" }), _jsx(DeprecatedSelect.Async, { "aria-label": "People That Can Help", id: "associatedPeople", loadOptions: this._fetchAssociatedPeople, multi: true, onChange: this.handleSelectChange("associatedPeople"), value: this.state.plan.associatedPeople
                                        ? this.state.plan.associatedPeople.map((person) => ({
                                            label: person.fullName,
                                            value: person,
                                        }))
                                        : [] })] }), this.state.resourcesAreActive && (_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "resources", children: "Resources" }), _jsx(DeprecatedSelect.Async, { id: "resources", "aria-label": "Resources", loadOptions: this._fetchResources, multi: true, onChange: this.handleSelectChange("resources"), value: this.state.plan.resources
                                        ? this.state.plan.resources.map((resource) => ({
                                            label: resource.name,
                                            value: resource,
                                        }))
                                        : [] })] })), _jsx(DragDropContext, { onDragEnd: this.handleDragEnd, children: _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "taskTemplateList", children: "Task Templates" }), _jsx(Droppable, { droppableId: "actionPlanTemplates", children: (provided) => (_jsx("div", { className: "list-group", id: "taskTemplateList", ref: provided.innerRef, children: this.state.plan.templates.map((template, index) => this.renderTemplate(template, index)) })) })] }) }), _jsx("div", { className: "form-group", children: _jsx("div", { className: "list-group", children: _jsx("div", { className: "list-group-item", children: _jsx(DeprecatedSelect.Async, { id: "addTaskTempalte", loadOptions: this._fetchTemplates, onChange: this.handleSelectTemplate, placeholder: "Type to add a template", style: { border: "none" } }) }) }) }), _jsx("div", { className: "form-group", children: _jsxs("button", { className: "btn btn-outline-secondary", type: "button", onClick: () => this.setState({ newTaskTemplateModalOpen: true }), children: [_jsx("span", { className: "fa fa-plus-circle text-success", "aria-hidden": true }), " ", "Create a New Task Template"] }) }), this.props.submitButton ? (this.props.submitButton) : (_jsx("div", { className: "form-group", children: _jsxs("button", { type: "submit", className: "btn btn-primary", disabled: this.state.saved || this.state.saving, children: [_jsx("span", { className: "fa fa-save" }), " " + saveButtonValue] }) }))] }), _jsx(TemplateModal, { modalId: "createTaskModal", onCloseModal: () => this.setState({ newTaskTemplateModalOpen: false }), onTemplateSubmit: this.handleAddTemplate, isModalOpen: this.state.newTaskTemplateModalOpen, modalHeader: "Create New Task Template", template: getBlankTaskTemplate(), submitButton: (submitTemplate) => (_jsxs("button", { className: "btn btn-primary", onClick: submitTemplate, children: [_jsx("span", { className: "fa fa-plus" }), " Create"] })) }), _jsx(TemplateModal, { modalId: "editTaskModal", onCloseModal: () => this.setState({
                        templateInEditModal: null,
                        templateInEditModalMetaInfo: {},
                    }), onTemplateSubmit: this.handleEditTemplate, isModalOpen: this.state.templateInEditModal != null, modalHeader: "Edit Task Template", template: this.state.templateInEditModal
                        ? this._stripMetaInfoFromTaskTemplate(this.state.templateInEditModal)
                        : getBlankTaskTemplate(), actionPlanTemplate: this.state.plan, submitButton: (submitTemplate) => (_jsxs("button", { className: "btn btn-primary", onClick: submitTemplate, children: [_jsx("span", { className: "fa fa-check" }), " Apply"] })) }), _jsx(Modal, { onCloseModal: () => this.setState({ templateToRemove: null }), isOpen: this.state.templateToRemove !== null, modalId: "removeTemplateModal", "aria-labelledby": "removeTemplateTitle", children: _jsx("div", { className: "modal-dialog", role: "document", children: _jsxs("div", { className: "modal-content", children: [_jsx("div", { className: "modal-header", children: _jsx("h5", { className: "modal-title", id: "deleteTemplateTitle", children: "Remove Task Template" }) }), _jsx("div", { className: "modal-body", children: "Are you sure you want to remove this task template?" }), _jsxs("div", { className: "modal-footer", children: [_jsxs("button", { type: "button", className: "btn btn-danger", onClick: () => this.handleDeleteTemplate(this.state.templateToRemove), children: [_jsx("span", { className: "fas fa-trash", "aria-hidden": true }), " Remove"] }), _jsx("button", { type: "button", className: "btn btn-outline-dark", onClick: () => this.setState({ templateToRemove: null }), children: "Cancel" })] })] }) }) })] }));
    }
}
